import { Flex, ModuleLayout, Space, Spacing } from '@billy/design-system'
import { useCallback, useState } from 'react'

import { useOrganizationViewUrl } from '../../../../../../hooks/routing/useOrganizationViewUrl'
import { useVatDeclaration } from '../../../../context/vatDeclarationContext'
import { useVatDeclarationsRoutes } from '../../../../context/vatDeclarationsRouteContext'
import { VatDeclarationsLoadingView } from '../../../VatDeclarationsLoadingView'
import { VatDeclarationsSubmissionFailedBanner } from '../../../VatDeclarationsSubmissionFailedBanner'
import { VatDeclarationIntegrationForm } from '../VatDeclarationIntegrationForm'
import { VatDeclarationReport } from '../VatDeclarationReport'
import { VatDeclarationSideActions } from '../VatDeclarationSideActions'
import { VatDeclarationStatusCard } from '../VatDeclarationStatusCard'
import { VatDeclarationTimeline } from '../VatDeclarationTimeline'
import * as Styled from './styles'

export const VatDeclarationViewNL = () => {
  const [showIntegrationForm, setShowIntegrationForm] = useState(false)
  const { isLoading, vatDeclaration, submission, isSubmissionFailedBannerClosed, isSubmissionFailed } =
    useVatDeclaration()
  const shouldShowFailedBanner = isSubmissionFailed && !isSubmissionFailedBannerClosed
  const shouldShowTimeline = submission?.detail?.timeline && submission?.detail?.timeline.length > 0
  const period = vatDeclaration?.periodText
  const vatDeclarationsRoutes = useVatDeclarationsRoutes()

  const { url: vatDeclarationsUrl } = useOrganizationViewUrl(vatDeclarationsRoutes.getMainRoute())

  const handleShowIntegrationForm = useCallback(
    (showForm: boolean) => {
      setShowIntegrationForm(showForm)
    },
    [setShowIntegrationForm],
  )

  const handleFormClose = useCallback(() => {
    setShowIntegrationForm(false)
  }, [])

  if (showIntegrationForm) {
    return <VatDeclarationIntegrationForm onBack={handleShowIntegrationForm} onSuccess={handleFormClose} />
  }

  if (isLoading || !vatDeclaration) {
    return <VatDeclarationsLoadingView />
  }

  return (
    <ModuleLayout
      backButtonTo={vatDeclarationsUrl}
      sideActions={<VatDeclarationSideActions onShowIntegrationForm={handleShowIntegrationForm} />}
      title={period}
      withBackButton
    >
      {shouldShowFailedBanner && (
        <>
          <VatDeclarationsSubmissionFailedBanner />
          <Space size="s24" />
        </>
      )}
      <Flex gap={Spacing.S32}>
        <VatDeclarationReport />
        <Styled.StatusCardWrapper>
          <VatDeclarationStatusCard />
          {shouldShowTimeline && <VatDeclarationTimeline />}
        </Styled.StatusCardWrapper>
      </Flex>
    </ModuleLayout>
  )
}
